<template>
    <v-container fluid class="pa-0">
    <!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
        <v-card-title >
            Champ du Quiz
            <v-spacer></v-spacer>
            <v-chip outlined color="secondary">
                    <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.updatedAt).format('DD MMMM YYYY') }}
            </v-chip>
        </v-card-title>
        <v-layout row wrap class="layout-flex-2" style="">
            <v-flex xs8>
                <v-text-field outlined dense class="rounded-lg" label="Titre" v-model="item.qiz_name" ></v-text-field>
            </v-flex>
            <!-- right side -->
            <v-flex xs4>
                <v-text-field outlined dense class="rounded-lg" type="color" label="Couleur" v-model="item.qiz_color"></v-text-field>
            </v-flex>
            <v-flex xs8>
                <v-select clearable outlined dense
                    :items="parentItems" item-text="qiz_name" item-value="qiz_id"
                    v-model="item.qiz_id_parent" label="Quiz parent (non obligatoire)">
                </v-select>
            </v-flex>
            <!-- right side -->
            <v-flex xs4></v-flex>
            <v-flex xs8>
                <v-textarea outlined dense rows="2" class="rounded-lg" label="Question" v-model="item.qiz_description"></v-textarea>
            </v-flex>
            <!-- right side -->
            <v-flex xs4>

            </v-flex>
            <v-flex xs8>
                <v-select :items="typeListByGroup['QTY']" item-text="typ_description" item-value="typ_id" outlined dense
                    v-model="item.qiz_typ_id_field" label="Type de champ" >
                </v-select>
            </v-flex>
            <!-- right side -->
            <v-flex xs4></v-flex>
            <v-flex xs8>
                
            </v-flex>
            <!-- right side -->
            <v-flex xs4></v-flex>
            <v-flex xs4>
                <v-radio-group v-model="item.qiz_visibility" mandatory>
                    <v-radio label="Actif" :value="1" ></v-radio>
                    <v-radio label="Innactif" :value="0" ></v-radio>
                </v-radio-group>
            </v-flex>
            <v-flex xs4>
                <v-radio-group v-model="item.qiz_onreport" mandatory>
                    <v-radio label="Sur le pdf" :value="1" ></v-radio>
                    <v-radio label="Caché (pdf)" :value="0" ></v-radio>
                </v-radio-group>
            </v-flex>
            <v-flex xs4>
                <v-btn icon @click="showCustom = !showCustom"><v-icon>mdi-application-braces-outline</v-icon></v-btn>
            </v-flex>
            <v-flex xs12 v-if="showCustom">
                <ListEditor v-model="item.qiz_customfields.list" label="Liste de valeurs"></ListEditor>
            </v-flex>
            <v-flex xs4>
                <v-select clearable outlined dense
                    :items="linkTypeItems" item-text="label" item-value="value"
                    v-model="item.qiz_link_type" label="Lien tâche (type)">
                </v-select>
            </v-flex>
            <v-flex xs8>
                <v-select clearable outlined dense
                    :items="taskTypeList" item-text="tty_name" item-value="tty_id"
                    v-model="item.qiz_tty_id" label="Tâche associée (non obligatoire)"
                    :disabled="!item.qiz_link_type">
                </v-select>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-btn class="rounded-xl" large color="red" v-if="item.uid" @click="deleteItem(item)"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-btn class="rounded-xl" large color="success" :loading="loading.fetchData" @click.native="saveItem()" :disabled="loading.fetchData">Enregistrer</v-btn>
            <v-btn class="rounded-xl" large color="primmary" :to="{ name: 'quizzes-list'}">Retour</v-btn>
        </v-card-actions>
    </v-card>
    <v-data-table v-bind:headers="headers" :items="childrenList" item-key="id" :search="search"
        items-per-page-text="Lignes par page" hide-default-header
        :items-per-page-options="pagination.rowsPerItem">
        <template v-slot:top>
            <v-row class="rounded-lg ma-0 pa-0">
                <v-col cols="6" md="6" class="pa-1"></v-col>
                <v-col cols="6" md="6" class="pa-1"></v-col>
            </v-row>
        </template>
        <template v-slot:[`item.qiz_name`]="{ item }"><v-chip class="ma-2" color="secondary">{{ item.qiz_name }}</v-chip><v-icon>mdi-arrow-right</v-icon></template>
        <template v-slot:[`item.qiz_id`]="{ item }">
            <v-btn rounded color="orange" elevation="0" dark :to="{ name: 'quizzes-edit', params: { qiz_id: item.qiz_id } }" @click="getItems()">
                <v-icon left  >{{item.qiz_id}} mdi-pencil</v-icon> Fiche 22
            </v-btn>
        </template>
        <template v-slot:no-data>
        <v-alert :value="( !childrenList.length )" color="error" icon="mdi-alert">
            Aucun evenement
        </v-alert>
        </template>
    </v-data-table>
    </v-container>
</template>
    
<script>
//import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import ListEditor from '@/components/ui/ListEditor'
import { mapState, mapWritableState, mapActions } from 'pinia'
import { useQuizStore } from '@/stores/quiz'

import { useTypeStore } from '@/stores/type'
import { useTaskTypeStore } from '@/stores/tasktype'

export default {
    name: 'quizzes-edit',
    components: { ListEditor }, //AutocompleteMulti
    computed: {
        ...mapWritableState(useQuizStore, {itemList: 'itemList', item: 'item' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useTaskTypeStore, {taskTypeList: 'itemList' }),
        linkTypeItems () {
            return [
                { label: 'Tâche à prévoir', value: 'PREV' },
                { label: 'Tâche réalisée',  value: 'DONE' },
            ]
        },
        parentItems () {
            // Liste des quiz pouvant être parents (on exclut l'item courant pour éviter l'auto-parentage)
            return this.itemList.filter( (quiz) => quiz.qiz_id !== this.item.qiz_id )
        },
        childrenList () {
            // Enfants de l'item courant (affichés dans le tableau)
            return this.itemList.filter( (quiz) => quiz.qiz_id_parent == this.$route.params.qiz_id )
        }
    },
    data: function () {
        return {
            loading: { fetchData: true },
            listEntities: [], listAgencies: [],
            search: null, searchAddress: null, searchBoxClosed: true, addressTab: [], timeOutHandle: 'off',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
                { text: 'Nom',    value: 'qiz_name', align: 'left'},
                { text: 'Type',   value: 'qiz_typ_id', align: 'left'},
                { text: 'Action', value: 'qiz_id', align: 'right'},
            ],
            showCustom: false
        }
    },
    async mounted () {
        this.getItems()
        this.fetchTaskTypes('?per_page=false')
    },
    methods: {
        ...mapActions(useQuizStore, {fetchItems: 'fetchItems', fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem'}),
        ...mapActions(useTaskTypeStore, {fetchTaskTypes: 'fetchItems'}),
        async saveItem () {
            // Enregistrement du formulaire
            this.loading.fetchData = true
            // Sécurité : la couleur ne doit jamais être nulle (contrainte SQL)
            if( !this.item.qiz_color ){
                this.item.qiz_color = '#2196F3'
            }
            if( parseInt( this.$route.params.qiz_id ) > 0 ){
                this.updateItem()
            } else {
                this.storeItem()
            }
            this.$router.push({ path: '/quizzes' })
        },
        async getItems(){
            this.loading.fetchData = false
            await this.fetchItem( this.$route.params.qiz_id, '?qiz_sta_id=GEN01' )

            // Récupération de tous les quiz (pour le choix du parent et la liste des enfants)
            await this.fetchItems('?per_page=false&qiz_sta_id=GEN01')
        }
    }
}
</script>